// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5981f7e6","455":"6a22c8e1","946":"5b06e578"}[chunkId] + ".chunk.js";
};